// extracted by mini-css-extract-plugin
module.exports = {"portal":"styles__portal__3JtNp","wrapper":"styles__wrapper__2_Sti","btn-close":"styles__btn-close__3i9U8","btnClose":"styles__btn-close__3i9U8"};